import RaytracingMonkey from "../../assets/projects/animation/monkey.png";
import ProceduralAnimation from "../../assets/projects/animation/procedural.png";
import FlockingModel from "../../assets/projects/animation/flocking.png";
import SpaceOut from "../../assets/projects/hackathon/spaceout.png";
import UTRA from "../../assets/projects/hackathon/utra.jpg";
import GoosePeak from "../../assets/projects/hackathon/goosepeak.jpg";
import StaticSite from "../../assets/projects/fullstack/hackthenorth-staticsite.png";
import VrSurgery from "../../assets/projects/games/vrsurgery.png";
import Splat from "../../assets/projects/games/splat.png";
import Gestures from "../../assets/projects/games/gestureControlled.jpg";
import RoboticsAnimator from "../../assets/projects/fullstack/animator.png";

const data = [
  {
    source: [RoboticsAnimator],
    title: "Robotics Animator",
    desc: "digital twin interface for animating robots",
    link: "https://github.com/IsaacYu15/RoboticsAnimator",
  },
  {
    source: [StaticSite],
    title: "Hack the North",
    desc: "frontend for canada's largest hackathon",
    link: "https://www.loom.com/share/88193fd39f2248a9aaa46972b54be6d6",
  },
  {
    source: [RaytracingMonkey],
    title: "Raytracing",
    desc: "rendering 3D models",
    link: "https://github.com/IsaacYu15/RaytracingFromScratch",
  },
  {
    source: [ProceduralAnimation],
    title: "Procedural Animation",
    desc: "real time walking animations for spiders",
    link: "https://github.com/IsaacYu15/ProceduralWalkingAnimation",
  },
  {
    source: [FlockingModel],
    title: "Flocking Model",
    desc: "simulating schools of fish",
    link: "https://github.com/IsaacYu15/Boids-Flocking-Algorithm",
  },
  {
    source: [Gestures],
    title: "Gesture Controlled Gaming",
    desc: "projection mapping and gestures for Balatro",
    link: "https://github.com/IsaacYu15/GestureControlledInterface/tree/main",
  },
  {
    source: [SpaceOut],
    title: "Space Out",
    desc: "flash card game, 1st place Clock Hacks",
    link: "https://devpost.com/software/spaced-out-fbv7tz",
  },
  {
    source: [UTRA],
    title: "WALL-E",
    desc: "closed challenge, 1st place UTRA",
    link: "https://devpost.com/software/wannabe-wall-e",
  },
  {
    source: [GoosePeak],
    title: "Goose Peak",
    desc: "AI productivity extension, Hack the North",
    link: "https://devpost.com/software/goosepeak-hixzd8",
  },
  {
    source: [VrSurgery],
    title: "VR Surgery",
    desc: "robotic surgery simulator",
    link: "https://github.com/IsaacYu15/VR-Surgery",
  },
  {
    source: [Splat],
    title: "SPLAT!",
    desc: "mobile platformer",
    link: "https://www.youtube.com/watch?v=xSwq6TVdwE0",
  },
];

export default data;
